import { formatPrice, getPrice } from 'utilities/content/content-utilities';
import { DeliveryAndReturnContentItem } from 'types/Product';

const getMidRangeHtml = (
  site: string | undefined,
  deliveryPrices: { type: string; value: number }[],
): DeliveryAndReturnContentItem => {
  const fallbackPricesVery: Record<string, number> = {
    STD: 8.99,
    NXT: 13.99,
    NOM: 13.99,
  };

  const fallbackPricesLittlewoods: Record<string, number> = {
    STD: 0.0,
    NXT: 5.99,
    NOM: 5.99,
    CPL: 0.0,
    CPNXT: 3.99,
  };

  const content: DeliveryAndReturnContentItem = {
    pageText: '',
    pageLink: '',
    modalHeading: '',
    modalBody: '',
  };

  if (site === 'very') {
    content.pageText = 'Delivery and returns';
    content.pageLink = 'More info';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <h3><strong>Delivery Options</strong></h3>
      <h4><strong>Home Delivery</strong></h4>
      <ul>
        <li>Standard Delivery: ${formatPrice(site, getPrice('STD', fallbackPricesVery, deliveryPrices))} - Expected delivery within 3-5 days.</li>
        <li>Next Day Delivery*: ${formatPrice(site, getPrice('NXT', fallbackPricesVery, deliveryPrices))} - Expected delivery the next working day.</li>
        <li>Nominated Day Delivery*: ${formatPrice(site, getPrice('NOM', fallbackPricesVery, deliveryPrices))} - Book delivery up to 10 days in advance.</li>
      </ul>
      <p>Delivery dates and charges will be calculated at checkout based on your order time and selection.</p>
      <p>All deliveries are made Monday to Friday, between 7am and 9pm, excluding bank holidays.</p>
      <p>*Available for selected items.</p>
      <br>
      <h3><strong>Returns</strong></h3>
      <p>Returns are free under our 28 day approval guarantee. You can arrange a return through My Account.</p>
    `;

    return content;
  }

  if (site === 'littlewoods') {
    content.pageText = 'FREE Delivery and returns';
    content.pageLink = 'More info';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <h3><strong>Delivery</strong></h3>
      <h4><strong>All deliveries made Mon-Fri excluding bank holidays</strong></h4>
      <h5><strong>Standard Delivery</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('STD', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Expected delivery: Usually within 3-5 days</li>
      </ul>
      <h5><strong>Next day delivery</strong></h5>
      <h5><strong>(available on most small items)</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('NXT', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Order by 10pm, Sun - Fri</li>
        <li>Expected delivery: Next day between 7am - 9pm</li>
      </ul>
      <h5><strong>Nominated day delivery</strong></h5>
      <h5><strong>(available on most small items)</strong></h5>
      <ul>
        <li>${formatPrice(site, getPrice('NOM', fallbackPricesLittlewoods, deliveryPrices))}</li>
        <li>Book delivery up to 10 days in advance</li>
        <li>Expected delivery: Next day between 7am - 9pm.</li>
      </ul>
       <h3><strong>Returns</strong></h3>
       <p>Returns of large and bulky items are free and easy under our 28-day home approval guarantee.</p>
       <p>You can arrange a return by home collection through My Account.</p>
  `;

    return content;
  }

  return content;
};

export default getMidRangeHtml;
